// Completezza delle giornate: 8h per i giorni lavorativi passati; nessun obbligo con assenza (intera o parziale),
// nei weekend, oggi e nei giorni futuri. L'assenza parziale è un permesso di durata non registrata: senza le ore
// del permesso non si può dire quante ore mancano, quindi il giorno non viene controllato.
export const FULL_DAY_MINUTES = 480;

// Colori allineati alla Monthly Tracking: assenza intera rossa con "OFF", assenza parziale gialla.
// Giorno incompleto arancione (più scuro del giallo), nessuna ora rossa con "0".
export const STATUS_STYLE = {
  ok: { bg: undefined, color: 'text.primary' },
  partial: { bg: 'rgba(249,168,37,0.18)', color: 'text.primary', title: 'Partial absence' },
  under: { bg: 'rgba(239,108,0,0.28)', color: 'var(--rt-warn)', title: 'Fewer hours than required' },
  missing: { bg: 'rgba(229,57,53,0.14)', color: 'var(--rt-danger)', title: 'No hours' },
  absence: { bg: 'rgba(229,57,53,0.12)', color: 'var(--rt-danger)', title: 'Absence · full day' },
  weekend: { bg: 'var(--rt-weekend)', color: 'text.secondary' },
  today: { bg: undefined, color: 'text.primary' },
  future: { bg: undefined, color: 'var(--rt-forecast)' },
};

/**
 * @param {{ actual: number, forecast: number }|undefined} cell
 * @param {object|undefined} absence
 * @param {{ weekend: boolean, today: boolean, future: boolean }} day
 * @returns {{ status: string, minutes: number, missing: number, target: number }}
 */
export function dayStatus(cell, absence, day) {
  const actual = cell?.actual || 0;
  const base = { minutes: actual, missing: 0, target: 0 };
  if (day.future) {
    // Le assenze future (ferie pianificate) si vedono come quelle passate; nessun obbligo di ore
    const status = day.weekend || !absence ? 'future' : absence.full_day ? 'absence' : 'partial';
    return { ...base, status, minutes: cell?.forecast || 0 };
  }
  if (day.weekend) return { ...base, status: 'weekend' };
  if (absence?.full_day) return { ...base, status: 'absence' };
  if (absence) return { ...base, status: 'partial' };
  if (day.today) return { ...base, status: 'today' };
  const target = FULL_DAY_MINUTES;
  if (actual < target) return { ...base, status: actual ? 'under' : 'missing', missing: target - actual, target };
  return { ...base, status: 'ok', target };
}

/** Riepilogo mensile di una persona: stati per giorno, totale consuntivo e ore mancanti fino a ieri. */
export function summarizePerson(days, absences, monthDays) {
  let total = 0;
  let missing = 0;
  let incompleteDays = 0;
  const statuses = monthDays.map((d) => {
    const s = dayStatus(days?.[d.day], absences?.get(d.day), d);
    total += days?.[d.day]?.actual || 0;
    missing += s.missing;
    if (s.missing > 0) incompleteDays += 1;
    return s;
  });
  return { statuses, total, missing, incompleteDays };
}
